export default "/react/wow-blogger-203b3ed2.svg";